import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatErr } from "@/lib/api";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await register(email, password, name); nav("/profile/edit"); }
    catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <p className="overline mb-3">Join Hoomanz</p>
          <h1 className="h-display text-4xl mb-2">Make a living doing what you love.</h1>
          <p className="text-[#4A4A4A] mb-6">Set up your profile in minutes. AI helps with the bio.</p>
          <GoogleButton testid="register-google" label="Continue with Google"/>
          <div className="flex items-center gap-3 my-6 text-xs uppercase tracking-widest text-[#8A8A8A]">
            <span className="flex-1 h-px bg-[#E5E5E3]"/>or sign up with email<span className="flex-1 h-px bg-[#E5E5E3]"/>
          </div>
          <label className="block mb-4">
            <span className="text-sm text-[#4A4A4A]">Your name</span>
            <input required value={name} onChange={(e)=>setName(e.target.value)} className="input mt-1.5" data-testid="register-name" />
          </label>
          <label className="block mb-4">
            <span className="text-sm text-[#4A4A4A]">Email</span>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="input mt-1.5" data-testid="register-email" />
          </label>
          <label className="block mb-6">
            <span className="text-sm text-[#4A4A4A]">Password</span>
            <input type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="input mt-1.5" data-testid="register-password" />
          </label>
          {err && <p className="text-sm text-[#B84B4B] mb-4" data-testid="register-error">{err}</p>}
          <button className="btn-primary w-full" disabled={loading} data-testid="register-submit">
            {loading ? "..." : "Create my profile"}
          </button>
          <p className="mt-6 text-sm text-[#4A4A4A]">
            Have an account? <Link to="/login" className="text-[#0A0A0A] underline" data-testid="register-to-login">Log in</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img className="absolute inset-0 w-full h-full object-cover" alt=""
          src="https://images.unsplash.com/photo-1581349485608-9469926a8e5e?w=1400&q=80" />
        <div className="absolute inset-0 bg-gradient-to-bl from-black/30 to-transparent" />
      </div>
    </div>
  );
}
